import queryKeys from '@/constants/queryKeys';
import { getMyOrganizationReport } from '@/services/api/requests/organization';
import { useQuery } from '@tanstack/react-query';

const useOrganizationReport = (year?: number, month?: number) => {
  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.organization.report, year, month],
    queryFn: async () => {
      const response = await getMyOrganizationReport(year, month);

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export default useOrganizationReport;
